var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 52,
    viewBox: "0 0 45 52",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1655_40081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79578 40.9121C8.61433 41.9673 9.54146 42.9321 10.5616 43.7904C13.9126 46.6091 18.1382 48.153 22.5021 48.153C26.8659 48.153 31.0915 46.6091 34.4425 43.7904C35.4611 42.9334 36.3868 41.97 37.2041 40.9164L39.2363 44.4621C37.1301 46.8355 34.5509 48.734 31.6673 50.0336C28.7837 51.3333 25.6606 52.0048 22.5021 52.0043C17.4692 52.0091 12.5813 50.3048 8.62638 47.1661C7.59736 46.3487 6.63959 45.4441 5.76355 44.4621L7.79578 40.9121Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9691 7.91203L33.5149 14.1065C35.8934 15.8554 37.8281 18.1467 39.1609 20.7934C40.4938 23.44 41.1871 26.367 41.1843 29.3353C41.1854 30.3134 41.1093 31.2901 40.9566 32.2561L29.2186 11.7341L26.4991 6.98095L22.5021 0L18.5051 6.98095L15.7856 11.7341L4.04338 32.2348C3.51451 28.8155 3.92907 25.3153 5.24167 22.1177C6.55427 18.9202 8.71427 16.1485 11.4851 14.1065L15.0309 7.91203C11.8451 9.03502 8.95133 10.8676 6.56465 13.2737C4.17797 15.6797 2.3598 18.5972 1.2453 21.8093C0.130795 25.0215 -0.251369 28.4456 0.127216 31.8272C0.5058 35.2087 1.63539 38.4608 3.43202 41.3415L5.61604 37.3664L8.20903 32.6642L14.3352 21.9377L22.5021 7.69945L24.1296 10.5437L36.7783 32.6515L39.4008 37.2856L41.6397 41.2395C43.8442 37.6668 45.0126 33.5431 45.0126 29.3353C45.0097 24.6342 43.5614 20.0496 40.8673 16.2129C38.1731 12.3762 34.3656 9.47614 29.9691 7.91203Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53711 39.0889H35.4965L22.5189 16.4199L9.53711 39.0889ZM16.8396 34.8374L22.5189 24.9229L28.194 34.8374H16.8396Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1655_40081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 52,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.56abb66e8fe146795991ef46964a3e1f.svg";
export { ForwardRef as ReactComponent };